export const organizationsTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
  FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
  FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
  FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
  CREATE_ONE_REQUEST: "CREATE_ONE_REQUEST",
  CREATE_ONE_SUCCESS: "CREATE_ONE_SUCCESS",
  CREATE_ONE_FAILURE: "CREATE_ONE_FAILURE",
  UPDATE_ONE_REQUEST: "UPDATE_ONE_REQUEST",
  UPDATE_ONE_SUCCESS: "UPDATE_ONE_SUCCESS",
  UPDATE_ONE_FAILURE: "UPDATE_ONE_FAILURE",
  DELETE_ONE_REQUEST: "DELETE_ONE_REQUEST",
  DELETE_ONE_SUCCESS: "DELETE_ONE_SUCCESS",
  DELETE_ONE_FAILURE: "DELETE_ONE_FAILURE",
  SET_CURRENT_ORGANIZATION: "SET_CURRENT_ORGANIZATION",
  FETCH_ALL_LOCATIONS_REQUEST: "FETCH_ALL_LOCATIONS_REQUEST",
  FETCH_ALL_LOCATIONS_SUCCESS: "FETCH_ALL_LOCATIONS_SUCCESS",
  FETCH_ALL_LOCATIONS_FAILURE: "FETCH_ALL_LOCATIONS_FAILURE",
  ADD_LOCATION_REQUEST: "ADD_LOCATION_REQUEST",
  ADD_LOCATION_SUCCESS: "ADD_LOCATION_SUCCESS",
  ADD_LOCATION_FAILURE: "ADD_LOCATION_FAILURE",
  REMOVE_LOCATION_REQUEST: "REMOVE_LOCATION_REQUEST",
  REMOVE_LOCATION_SUCCESS: "REMOVE_LOCATION_SUCCESS",
  REMOVE_LOCATION_FAILURE: "REMOVE_LOCATION_FAILURE",
  FETCH_LOCATION_USERS_REQUEST: "FETCH_LOCATION_USERS_REQUEST",
  FETCH_LOCATION_USERS_SUCCESS: "FETCH_LOCATION_USERS_SUCCESS",
  FETCH_LOCATION_USERS_FAILURE: "FETCH_LOCATION_USERS_FAILURE",
  ADD_LOCATION_USER_REQUEST: "ADD_LOCATION_USER_REQUEST",
  ADD_LOCATION_USER_SUCCESS: "ADD_LOCATION_USER_SUCCESS",
  ADD_LOCATION_USER_FAILURE: "ADD_LOCATION_USER_FAILURE",
  REMOVE_LOCATION_USER_REQUEST: "REMOVE_LOCATION_USER_REQUEST",
  REMOVE_LOCATION_USER_SUCCESS: "REMOVE_LOCATION_USER_SUCCESS",
  REMOVE_LOCATION_USER_FAILURE: "REMOVE_LOCATION_USER_FAILURE",
  FETCH_ALL_CONCEPTS_REQUEST: "FETCH_ALL_CONCEPTS_REQUEST",
  FETCH_ALL_CONCEPTS_SUCCESS: "FETCH_ALL_CONCEPTS_SUCCESS",
  FETCH_ALL_CONCEPTS_FAILURE: "FETCH_ALL_CONCEPTS_FAILURE",
  ADD_CONCEPT_REQUEST: "ADD_CONCEPT_REQUEST",
  ADD_CONCEPT_SUCCESS: "ADD_CONCEPT_SUCCESS",
  ADD_CONCEPT_FAILURE: "ADD_CONCEPT_FAILURE",
  REMOVE_CONCEPT_REQUEST: "REMOVE_CONCEPT_REQUEST",
  REMOVE_CONCEPT_SUCCESS: "REMOVE_CONCEPT_SUCCESS",
  REMOVE_CONCEPT_FAILURE: "REMOVE_CONCEPT_FAILURE",
  FETCH_CONCEPT_USERS_REQUEST: "FETCH_CONCEPT_USERS_REQUEST",
  FETCH_CONCEPT_USERS_SUCCESS: "FETCH_CONCEPT_USERS_SUCCESS",
  FETCH_CONCEPT_USERS_FAILURE: "FETCH_CONCEPT_USERS_FAILURE",
  ADD_CONCEPT_USER_REQUEST: "ADD_CONCEPT_USER_REQUEST",
  ADD_CONCEPT_USER_SUCCESS: "ADD_CONCEPT_USER_SUCCESS",
  ADD_CONCEPT_USER_FAILURE: "ADD_CONCEPT_USER_FAILURE",
  REMOVE_CONCEPT_USER_REQUEST: "REMOVE_CONCEPT_USER_REQUEST",
  REMOVE_CONCEPT_USER_SUCCESS: "REMOVE_CONCEPT_USER_SUCCESS",
  REMOVE_CONCEPT_USER_FAILURE: "REMOVE_CONCEPT_USER_FAILURE",
  FETCH_ALL_USERS_REQUEST: "FETCH_ALL_USERS_REQUEST",
  FETCH_ALL_USERS_SUCCESS: "FETCH_ALL_USERS_SUCCESS",
  FETCH_ALL_USERS_FAILURE: "FETCH_ALL_USERS_FAILURE",
  CREATE_USER_REQUEST: "CREATE_USER_REQUEST",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_FAILURE: "CREATE_USER_FAILURE",
  REMOVE_USER_REQUEST: "REMOVE_USER_REQUEST",
  REMOVE_USER_SUCCESS: "REMOVE_USER_SUCCESS",
  REMOVE_USER_FAILURE: "REMOVE_USER_FAILURE",
  FETCH_ALL_ADMIN_USERS_REQUEST: "FETCH_ALL_ADMIN_USERS_REQUEST",
  FETCH_ALL_ADMIN_USERS_SUCCESS: "FETCH_ALL_ADMIN_USERS_SUCCESS",
  FETCH_ALL_ADMIN_USERS_FAILURE: "FETCH_ALL_ADMIN_USERS_FAILURE",
  ADD_ADMIN_TO_ORGANIZATION_REQUEST: "ADD_ADMIN_TO_ORGANIZATION_REQUEST",
  ADD_ADMIN_TO_ORGANIZATION_SUCCESS: "ADD_ADMIN_TO_ORGANIZATION_SUCCESS",
  ADD_ADMIN_TO_ORGANIZATION_FAILURE: "ADD_ADMIN_TO_ORGANIZATION_FAILURE",
  REMOVE_ADMIN_FROM_ORGANIZATION_REQUEST:
    "REMOVE_ADMIN_FROM_ORGANIZATION_REQUEST",
  REMOVE_ADMIN_FROM_ORGANIZATION_SUCCESS:
    "REMOVE_ADMIN_FROM_ORGANIZATION_SUCCESS",
  REMOVE_ADMIN_FROM_ORGANIZATION_FAILURE:
    "REMOVE_ADMIN_FROM_ORGANIZATION_FAILURE",
  FETCH_ALL_EDITOR_USERS_REQUEST: "FETCH_ALL_EDITOR_USERS_REQUEST",
  FETCH_ALL_EDITOR_USERS_SUCCESS: "FETCH_ALL_EDITOR_USERS_SUCCESS",
  FETCH_ALL_EDITOR_USERS_FAILURE: "FETCH_ALL_EDITOR_USERS_FAILURE",
  ADD_EDITOR_TO_ORGANIZATION_REQUEST: "ADD_EDITOR_TO_ORGANIZATION_REQUEST",
  ADD_EDITOR_TO_ORGANIZATION_SUCCESS: "ADD_EDITOR_TO_ORGANIZATION_SUCCESS",
  ADD_EDITOR_TO_ORGANIZATION_FAILURE: "ADD_EDITOR_TO_ORGANIZATION_FAILURE",
  REMOVE_EDITOR_FROM_ORGANIZATION_REQUEST:
    "REMOVE_EDITOR_FROM_ORGANIZATION_REQUEST",
  REMOVE_EDITOR_FROM_ORGANIZATION_SUCCESS:
    "REMOVE_EDITOR_FROM_ORGANIZATION_SUCCESS",
  REMOVE_EDITOR_FROM_ORGANIZATION_FAILURE:
    "REMOVE_EDITOR_FROM_ORGANIZATION_FAILURE",
  FETCH_ALL_VIEWER_USERS_REQUEST: "FETCH_ALL_VIEWER_USERS_REQUEST",
  FETCH_ALL_VIEWER_USERS_SUCCESS: "FETCH_ALL_VIEWER_USERS_SUCCESS",
  FETCH_ALL_VIEWER_USERS_FAILURE: "FETCH_ALL_VIEWER_USERS_FAILURE",
  ADD_VIEWER_TO_ORGANIZATION_REQUEST: "ADD_VIEWER_TO_ORGANIZATION_REQUEST",
  ADD_VIEWER_TO_ORGANIZATION_SUCCESS: "ADD_VIEWER_TO_ORGANIZATION_SUCCESS",
  ADD_VIEWER_TO_ORGANIZATION_FAILURE: "ADD_VIEWER_TO_ORGANIZATION_FAILURE",
  REMOVE_VIEWER_FROM_ORGANIZATION_REQUEST:
    "REMOVE_VIEWER_FROM_ORGANIZATION_REQUEST",
  REMOVE_VIEWER_FROM_ORGANIZATION_SUCCESS:
    "REMOVE_VIEWER_FROM_ORGANIZATION_SUCCESS",
  REMOVE_VIEWER_FROM_ORGANIZATION_FAILURE:
    "REMOVE_VIEWER_FROM_ORGANIZATION_FAILURE",
  FETCH_ALL_ORGANIZATION_GROUPS_REQUEST:
    "FETCH_ALL_ORGANIZATION_GROUPS_REQUEST",
  FETCH_ALL_ORGANIZATION_GROUPS_SUCCESS:
    "FETCH_ALL_ORGANIZATION_GROUPS_SUCCESS",
  FETCH_ALL_ORGANIZATION_GROUPS_FAILURE:
    "FETCH_ALL_ORGANIZATION_GROUPS_FAILURE",
  FETCH_ORGANIZATION_GROUP_REQUEST: "FETCH_ORGANIZATION_GROUP_REQUEST",
  FETCH_ORGANIZATION_GROUP_SUCCESS: "FETCH_ORGANIZATION_GROUP_SUCCESS",
  FETCH_ORGANIZATION_GROUP_FAILURE: "FETCH_ORGANIZATION_GROUP_FAILURE",
  CREATE_ORGANIZATION_GROUP_REQUEST: "CREATE_ORGANIZATION_GROUP_REQUEST",
  CREATE_ORGANIZATION_GROUP_SUCCESS: "CREATE_ORGANIZATION_GROUP_SUCCESS",
  CREATE_ORGANIZATION_GROUP_FAILURE: "CREATE_ORGANIZATION_GROUP_FAILURE",
  UPDATE_ORGANIZATION_GROUP_REQUEST: "UPDATE_ORGANIZATION_GROUP_REQUEST",
  UPDATE_ORGANIZATION_GROUP_SUCCESS: "UPDATE_ORGANIZATION_GROUP_SUCCESS",
  UPDATE_ORGANIZATION_GROUP_FAILURE: "UPDATE_ORGANIZATION_GROUP_FAILURE",
  DELETE_ORGANIZATION_GROUP_REQUEST: "DELETE_ORGANIZATION_GROUP_REQUEST",
  DELETE_ORGANIZATION_GROUP_SUCCESS: "DELETE_ORGANIZATION_GROUP_SUCCESS",
  DELETE_ORGANIZATION_GROUP_FAILURE: "DELETE_ORGANIZATION_GROUP_FAILURE",
  FETCH_ALL_ORGANIZATION_GROUP_USERS_REQUEST:
    "FETCH_ALL_ORGANIZATION_GROUP_USERS_REQUEST",
  FETCH_ALL_ORGANIZATION_GROUP_USERS_SUCCESS:
    "FETCH_ALL_ORGANIZATION_GROUP_USERS_SUCCESS",
  FETCH_ALL_ORGANIZATION_GROUP_USERS_FAILURE:
    "FETCH_ALL_ORGANIZATION_GROUP_USERS_FAILURE",
  ADD_USER_TO_ORGANIZATION_GROUP_REQUEST:
    "ADD_USER_TO_ORGANIZATION_GROUP_REQUEST",
  ADD_USER_TO_ORGANIZATION_GROUP_SUCCESS:
    "ADD_USER_TO_ORGANIZATION_GROUP_SUCCESS",
  ADD_USER_TO_ORGANIZATION_GROUP_FAILURE:
    "ADD_USER_TO_ORGANIZATION_GROUP_FAILURE",
  REMOVE_USER_FROM_ORGANIZATION_GROUP_REQUEST:
    "REMOVE_USER_FROM_ORGANIZATION_GROUP_REQUEST",
  REMOVE_USER_FROM_ORGANIZATION_GROUP_SUCCESS:
    "REMOVE_USER_FROM_ORGANIZATION_GROUP_SUCCESS",
  REMOVE_USER_FROM_ORGANIZATION_GROUP_FAILURE:
    "REMOVE_USER_FROM_ORGANIZATION_GROUP_FAILURE",
  FETCH_AVAILABLE_GROUP_ROLES_REQUEST: "FETCH_AVAILABLE_GROUP_ROLES_REQUEST",
  FETCH_AVAILABLE_GROUP_ROLES_SUCCESS: "FETCH_AVAILABLE_GROUP_ROLES_SUCCESS",
  FETCH_AVAILABLE_GROUP_ROLES_FAILURE: "FETCH_AVAILABLE_GROUP_ROLES_FAILURE",
  FETCH_ORGANIZATION_GROUP_ROLES_REQUEST:
    "FETCH_ORGANIZATION_GROUP_ROLES_REQUEST",
  FETCH_ORGANIZATION_GROUP_ROLES_SUCCESS:
    "FETCH_ORGANIZATION_GROUP_ROLES_SUCCESS",
  FETCH_ORGANIZATION_GROUP_ROLES_FAILURE:
    "FETCH_ORGANIZATION_GROUP_ROLES_FAILURE",
  ADD_ORGANIZATION_GROUP_ROLE_REQUEST: "ADD_ORGANIZATION_GROUP_ROLE_REQUEST",
  ADD_ORGANIZATION_GROUP_ROLE_SUCCESS: "ADD_ORGANIZATION_GROUP_ROLE_SUCCESS",
  ADD_ORGANIZATION_GROUP_ROLE_FAILURE: "ADD_ORGANIZATION_GROUP_ROLE_FAILURE",
  REMOVE_ORGANIZATION_GROUP_ROLE_REQUEST:
    "REMOVE_ORGANIZATION_GROUP_ROLE_REQUEST",
  REMOVE_ORGANIZATION_GROUP_ROLE_SUCCESS:
    "REMOVE_ORGANIZATION_GROUP_ROLE_SUCCESS",
  REMOVE_ORGANIZATION_GROUP_ROLE_FAILURE:
    "REMOVE_ORGANIZATION_GROUP_ROLE_FAILURE",
};

export const scopesTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
  FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
  FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
  FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
  CREATE_ONE_REQUEST: "CREATE_ONE_REQUEST",
  CREATE_ONE_SUCCESS: "CREATE_ONE_SUCCESS",
  CREATE_ONE_FAILURE: "CREATE_ONE_FAILURE",
  UPDATE_ONE_REQUEST: "UPDATE_ONE_REQUEST",
  UPDATE_ONE_SUCCESS: "UPDATE_ONE_SUCCESS",
  UPDATE_ONE_FAILURE: "UPDATE_ONE_FAILURE",
  DELETE_ONE_REQUEST: "DELETE_ONE_REQUEST",
  DELETE_ONE_SUCCESS: "DELETE_ONE_SUCCESS",
  DELETE_ONE_FAILURE: "DELETE_ONE_FAILURE",
  FETCH_ALL_CURRENT_ROLES_REQUEST: "FETCH_ALL_CURRENT_ROLES_REQUEST",
  FETCH_ALL_CURRENT_ROLES_SUCCESS: "FETCH_ALL_CURRENT_ROLES_SUCCESS",
  FETCH_ALL_CURRENT_ROLES_FAILURE: "FETCH_ALL_CURRENT_ROLES_FAILURE",
  FETCH_ALL_AVAILABLE_ROLES_REQUEST: "FETCH_ALL_AVAILABLE_ROLES_REQUEST",
  FETCH_ALL_AVAILABLE_ROLES_SUCCESS: "FETCH_ALL_AVAILABLE_ROLES_SUCCESS",
  FETCH_ALL_AVAILABLE_ROLES_FAILURE: "FETCH_ALL_AVAILABLE_ROLES_FAILURE",
  ADD_ROLE_TO_SCOPE_REQUEST: "ADD_ROLE_TO_SCOPE_REQUEST",
  ADD_ROLE_TO_SCOPE_SUCCESS: "ADD_ROLE_TO_SCOPE_SUCCESS",
  ADD_ROLE_TO_SCOPE_FAILURE: "ADD_ROLE_TO_SCOPE_FAILURE",
  REMOVE_ROLE_FROM_SCOPE_REQUEST: "REMOVE_ROLE_FROM_SCOPE_REQUEST",
  REMOVE_ROLE_FROM_SCOPE_SUCCESS: "REMOVE_ROLE_FROM_SCOPE_SUCCESS",
  REMOVE_ROLE_FROM_SCOPE_FAILURE: "REMOVE_ROLE_FROM_SCOPE_FAILURE",
};

export const rolesTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
  FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
  FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
  FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
  CREATE_ONE_REQUEST: "CREATE_ONE_REQUEST",
  CREATE_ONE_SUCCESS: "CREATE_ONE_SUCCESS",
  CREATE_ONE_FAILURE: "CREATE_ONE_FAILURE",
  UPDATE_ONE_REQUEST: "UPDATE_ONE_REQUEST",
  UPDATE_ONE_SUCCESS: "UPDATE_ONE_SUCCESS",
  UPDATE_ONE_FAILURE: "UPDATE_ONE_FAILURE",
  DELETE_ONE_REQUEST: "DELETE_ONE_REQUEST",
  DELETE_ONE_SUCCESS: "DELETE_ONE_SUCCESS",
  DELETE_ONE_FAILURE: "DELETE_ONE_FAILURE",
};

export const navigationTypes = {};

export const apisTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
  FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
  FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
  FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
  CREATE_ONE_REQUEST: "CREATE_ONE_REQUEST",
  CREATE_ONE_SUCCESS: "CREATE_ONE_SUCCESS",
  CREATE_ONE_FAILURE: "CREATE_ONE_FAILURE",
  UPDATE_ONE_REQUEST: "UPDATE_ONE_REQUEST",
  UPDATE_ONE_SUCCESS: "UPDATE_ONE_SUCCESS",
  UPDATE_ONE_FAILURE: "UPDATE_ONE_FAILURE",
  DELETE_ONE_REQUEST: "DELETE_ONE_REQUEST",
  DELETE_ONE_SUCCESS: "DELETE_ONE_SUCCESS",
  DELETE_ONE_FAILURE: "DELETE_ONE_FAILURE",
  RETRIEVE_CREDENTIALS_REQUEST: "RETRIEVE_CREDENTIALS_REQUEST",
  RETRIEVE_CREDENTIALS_SUCCESS: "RETRIEVE_CREDENTIALS_SUCCESS",
  RETRIEVE_CREDENTIALS_FAILURE: "RETRIEVE_CREDENTIALS_FAILURE",
  FETCH_ALL_SERVICE_ACCOUNT_ROLES_REQUEST:
    "FETCH_ALL_SERVICE_ACCOUNT_ROLES_REQUEST",
  FETCH_ALL_SERVICE_ACCOUNT_ROLES_SUCCESS:
    "FETCH_ALL_SERVICE_ACCOUNT_ROLES_SUCCESS",
  FETCH_ALL_SERVICE_ACCOUNT_ROLES_FAILURE:
    "FETCH_ALL_SERVICE_ACCOUNT_ROLES_FAILURE",
  FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_REQUEST:
    "FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_REQUEST",
  FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_SUCCESS:
    "FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_SUCCESS",
  FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_FAILURE:
    "FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_FAILURE",
  ADD_ROLES_TO_SERVICE_ACCOUNT_REQUEST: "ADD_ROLES_TO_SERVICE_ACCOUNT_REQUEST",
  ADD_ROLES_TO_SERVICE_ACCOUNT_SUCCESS: "ADD_ROLES_TO_SERVICE_ACCOUNT_SUCCESS",
  ADD_ROLES_TO_SERVICE_ACCOUNT_FAILURE: "ADD_ROLES_TO_SERVICE_ACCOUNT_FAILURE",
  REMOVE_ROLES_FROM_SERVICE_ACCOUNT_REQUEST:
    "REMOVE_ROLES_FROM_SERVICE_ACCOUNT_REQUEST",
  REMOVE_ROLES_FROM_SERVICE_ACCOUNT_SUCCESS:
    "REMOVE_ROLES_FROM_SERVICE_ACCOUNT_SUCCESS",
  REMOVE_ROLES_FROM_SERVICE_ACCOUNT_FAILURE:
    "REMOVE_ROLES_FROM_SERVICE_ACCOUNT_FAILURE",
  FETCH_ALL_DEFAULT_SCOPES_REQUEST: "FETCH_ALL_DEFAULT_SCOPES_REQUEST",
  FETCH_ALL_DEFAULT_SCOPES_SUCCESS: "FETCH_ALL_DEFAULT_SCOPES_SUCCESS",
  FETCH_ALL_DEFAULT_SCOPES_FAILURE: "FETCH_ALL_DEFAULT_SCOPES_FAILURE",
  ADD_DEFAULT_SCOPE_REQUEST: "ADD_DEFAULT_SCOPE_REQUEST",
  ADD_DEFAULT_SCOPE_SUCCESS: "ADD_DEFAULT_SCOPE_SUCCESS",
  ADD_DEFAULT_SCOPE_FAILURE: "ADD_DEFAULT_SCOPE_FAILURE",
  REMOVE_DEFAULT_SCOPE_REQUEST: "REMOVE_DEFAULT_SCOPE_REQUEST",
  REMOVE_DEFAULT_SCOPE_SUCCESS: "REMOVE_DEFAULT_SCOPE_SUCCESS",
  REMOVE_DEFAULT_SCOPE_FAILURE: "REMOVE_DEFAULT_SCOPE_FAILURE",
  FETCH_ALL_OPTIONAL_SCOPES_REQUEST: "FETCH_ALL_OPTIONAL_SCOPES_REQUEST",
  FETCH_ALL_OPTIONAL_SCOPES_SUCCESS: "FETCH_ALL_OPTIONAL_SCOPES_SUCCESS",
  FETCH_ALL_OPTIONAL_SCOPES_FAILURE: "FETCH_ALL_OPTIONAL_SCOPES_FAILURE",
  ADD_OPTIONAL_SCOPE_REQUEST: "ADD_OPTIONAL_SCOPE_REQUEST",
  ADD_OPTIONAL_SCOPE_SUCCESS: "ADD_OPTIONAL_SCOPE_SUCCESS",
  ADD_OPTIONAL_SCOPE_FAILURE: "ADD_OPTIONAL_SCOPE_FAILURE",
  REMOVE_OPTIONAL_SCOPE_REQUEST: "REMOVE_OPTIONAL_SCOPE_REQUEST",
  REMOVE_OPTIONAL_SCOPE_SUCCESS: "REMOVE_OPTIONAL_SCOPE_SUCCESS",
  REMOVE_OPTIONAL_SCOPE_FAILURE: "REMOVE_OPTIONAL_SCOPE_FAILURE",
};

export const frontsTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
  FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
  FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
  FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
  CREATE_ONE_REQUEST: "CREATE_ONE_REQUEST",
  CREATE_ONE_SUCCESS: "CREATE_ONE_SUCCESS",
  CREATE_ONE_FAILURE: "CREATE_ONE_FAILURE",
  UPDATE_ONE_REQUEST: "UPDATE_ONE_REQUEST",
  UPDATE_ONE_SUCCESS: "UPDATE_ONE_SUCCESS",
  UPDATE_ONE_FAILURE: "UPDATE_ONE_FAILURE",
  DELETE_ONE_REQUEST: "DELETE_ONE_REQUEST",
  DELETE_ONE_SUCCESS: "DELETE_ONE_SUCCESS",
  DELETE_ONE_FAILURE: "DELETE_ONE_FAILURE",
  FETCH_ALL_DEFAULT_SCOPES_REQUEST: "FETCH_ALL_DEFAULT_SCOPES_REQUEST",
  FETCH_ALL_DEFAULT_SCOPES_SUCCESS: "FETCH_ALL_DEFAULT_SCOPES_SUCCESS",
  FETCH_ALL_DEFAULT_SCOPES_FAILURE: "FETCH_ALL_DEFAULT_SCOPES_FAILURE",
  ADD_DEFAULT_SCOPE_REQUEST: "ADD_DEFAULT_SCOPE_REQUEST",
  ADD_DEFAULT_SCOPE_SUCCESS: "ADD_DEFAULT_SCOPE_SUCCESS",
  ADD_DEFAULT_SCOPE_FAILURE: "ADD_DEFAULT_SCOPE_FAILURE",
  REMOVE_DEFAULT_SCOPE_REQUEST: "REMOVE_DEFAULT_SCOPE_REQUEST",
  REMOVE_DEFAULT_SCOPE_SUCCESS: "REMOVE_DEFAULT_SCOPE_SUCCESS",
  REMOVE_DEFAULT_SCOPE_FAILURE: "REMOVE_DEFAULT_SCOPE_FAILURE",
  FETCH_ALL_OPTIONAL_SCOPES_REQUEST: "FETCH_ALL_OPTIONAL_SCOPES_REQUEST",
  FETCH_ALL_OPTIONAL_SCOPES_SUCCESS: "FETCH_ALL_OPTIONAL_SCOPES_SUCCESS",
  FETCH_ALL_OPTIONAL_SCOPES_FAILURE: "FETCH_ALL_OPTIONAL_SCOPES_FAILURE",
  ADD_OPTIONAL_SCOPE_REQUEST: "ADD_OPTIONAL_SCOPE_REQUEST",
  ADD_OPTIONAL_SCOPE_SUCCESS: "ADD_OPTIONAL_SCOPE_SUCCESS",
  ADD_OPTIONAL_SCOPE_FAILURE: "ADD_OPTIONAL_SCOPE_FAILURE",
  REMOVE_OPTIONAL_SCOPE_REQUEST: "REMOVE_OPTIONAL_SCOPE_REQUEST",
  REMOVE_OPTIONAL_SCOPE_SUCCESS: "REMOVE_OPTIONAL_SCOPE_SUCCESS",
  REMOVE_OPTIONAL_SCOPE_FAILURE: "REMOVE_OPTIONAL_SCOPE_FAILURE",
};

export const serviceAccountsTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
  FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
  FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
  FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
  CREATE_ONE_REQUEST: "CREATE_ONE_REQUEST",
  CREATE_ONE_SUCCESS: "CREATE_ONE_SUCCESS",
  CREATE_ONE_FAILURE: "CREATE_ONE_FAILURE",
  UPDATE_ONE_REQUEST: "UPDATE_ONE_REQUEST",
  UPDATE_ONE_SUCCESS: "UPDATE_ONE_SUCCESS",
  UPDATE_ONE_FAILURE: "UPDATE_ONE_FAILURE",
  DELETE_ONE_REQUEST: "DELETE_ONE_REQUEST",
  DELETE_ONE_SUCCESS: "DELETE_ONE_SUCCESS",
  DELETE_ONE_FAILURE: "DELETE_ONE_FAILURE",
  RETRIEVE_CREDENTIALS_REQUEST: "RETRIEVE_CREDENTIALS_REQUEST",
  RETRIEVE_CREDENTIALS_SUCCESS: "RETRIEVE_CREDENTIALS_SUCCESS",
  RETRIEVE_CREDENTIALS_FAILURE: "RETRIEVE_CREDENTIALS_FAILURE",
  FETCH_ALL_SERVICE_ACCOUNT_ROLES_REQUEST:
    "FETCH_ALL_SERVICE_ACCOUNT_ROLES_REQUEST",
  FETCH_ALL_SERVICE_ACCOUNT_ROLES_SUCCESS:
    "FETCH_ALL_SERVICE_ACCOUNT_ROLES_SUCCESS",
  FETCH_ALL_SERVICE_ACCOUNT_ROLES_FAILURE:
    "FETCH_ALL_SERVICE_ACCOUNT_ROLES_FAILURE",
  FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_REQUEST:
    "FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_REQUEST",
  FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_SUCCESS:
    "FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_SUCCESS",
  FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_FAILURE:
    "FETCH_ALL_SERVICE_ACCOUNT_AVAILABLE_ROLES_FAILURE",
  ADD_ROLES_TO_SERVICE_ACCOUNT_REQUEST: "ADD_ROLES_TO_SERVICE_ACCOUNT_REQUEST",
  ADD_ROLES_TO_SERVICE_ACCOUNT_SUCCESS: "ADD_ROLES_TO_SERVICE_ACCOUNT_SUCCESS",
  ADD_ROLES_TO_SERVICE_ACCOUNT_FAILURE: "ADD_ROLES_TO_SERVICE_ACCOUNT_FAILURE",
  REMOVE_ROLES_FROM_SERVICE_ACCOUNT_REQUEST:
    "REMOVE_ROLES_FROM_SERVICE_ACCOUNT_REQUEST",
  REMOVE_ROLES_FROM_SERVICE_ACCOUNT_SUCCESS:
    "REMOVE_ROLES_FROM_SERVICE_ACCOUNT_SUCCESS",
  REMOVE_ROLES_FROM_SERVICE_ACCOUNT_FAILURE:
    "REMOVE_ROLES_FROM_SERVICE_ACCOUNT_FAILURE",
  FETCH_ALL_DEFAULT_SCOPES_REQUEST: "FETCH_ALL_DEFAULT_SCOPES_REQUEST",
  FETCH_ALL_DEFAULT_SCOPES_SUCCESS: "FETCH_ALL_DEFAULT_SCOPES_SUCCESS",
  FETCH_ALL_DEFAULT_SCOPES_FAILURE: "FETCH_ALL_DEFAULT_SCOPES_FAILURE",
  ADD_DEFAULT_SCOPE_REQUEST: "ADD_DEFAULT_SCOPE_REQUEST",
  ADD_DEFAULT_SCOPE_SUCCESS: "ADD_DEFAULT_SCOPE_SUCCESS",
  ADD_DEFAULT_SCOPE_FAILURE: "ADD_DEFAULT_SCOPE_FAILURE",
  REMOVE_DEFAULT_SCOPE_REQUEST: "REMOVE_DEFAULT_SCOPE_REQUEST",
  REMOVE_DEFAULT_SCOPE_SUCCESS: "REMOVE_DEFAULT_SCOPE_SUCCESS",
  REMOVE_DEFAULT_SCOPE_FAILURE: "REMOVE_DEFAULT_SCOPE_FAILURE",
  FETCH_ALL_OPTIONAL_SCOPES_REQUEST: "FETCH_ALL_OPTIONAL_SCOPES_REQUEST",
  FETCH_ALL_OPTIONAL_SCOPES_SUCCESS: "FETCH_ALL_OPTIONAL_SCOPES_SUCCESS",
  FETCH_ALL_OPTIONAL_SCOPES_FAILURE: "FETCH_ALL_OPTIONAL_SCOPES_FAILURE",
  ADD_OPTIONAL_SCOPE_REQUEST: "ADD_OPTIONAL_SCOPE_REQUEST",
  ADD_OPTIONAL_SCOPE_SUCCESS: "ADD_OPTIONAL_SCOPE_SUCCESS",
  ADD_OPTIONAL_SCOPE_FAILURE: "ADD_OPTIONAL_SCOPE_FAILURE",
  REMOVE_OPTIONAL_SCOPE_REQUEST: "REMOVE_OPTIONAL_SCOPE_REQUEST",
  REMOVE_OPTIONAL_SCOPE_SUCCESS: "REMOVE_OPTIONAL_SCOPE_SUCCESS",
  REMOVE_OPTIONAL_SCOPE_FAILURE: "REMOVE_OPTIONAL_SCOPE_FAILURE",
};

export const locationsTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
};

export const kitchensTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
};

export const conceptsTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
};

export const usersTypes = {
  FETCH_ALL_REQUEST: "FETCH_ALL_REQUEST",
  FETCH_ALL_SUCCESS: "FETCH_ALL_SUCCESS",
  FETCH_ALL_FAILURE: "FETCH_ALL_FAILURE",
  FETCH_ONE_REQUEST: "FETCH_ONE_REQUEST",
  FETCH_ONE_SUCCESS: "FETCH_ONE_SUCCESS",
  FETCH_ONE_FAILURE: "FETCH_ONE_FAILURE",
  CREATE_ONE_REQUEST: "CREATE_ONE_REQUEST",
  CREATE_ONE_SUCCESS: "CREATE_ONE_SUCCESS",
  CREATE_ONE_FAILURE: "CREATE_ONE_FAILURE",
  UPDATE_ONE_REQUEST: "UPDATE_ONE_REQUEST",
  UPDATE_ONE_SUCCESS: "UPDATE_ONE_SUCCESS",
  UPDATE_ONE_FAILURE: "UPDATE_ONE_FAILURE",
  DELETE_ONE_REQUEST: "DELETE_ONE_REQUEST",
  DELETE_ONE_SUCCESS: "DELETE_ONE_SUCCESS",
  DELETE_ONE_FAILURE: "DELETE_ONE_FAILURE",
};

export const profileTypes = {
  FETCH_PROFILE_REQUEST: "FETCH_PROFILE_REQUEST",
  FETCH_PROFILE_SUCCESS: "FETCH_PROFILE_SUCCESS",
  FETCH_PROFILE_FAILURE: "FETCH_PROFILE_FAILURE",
};
